<template>
  <el-dialog :visible.sync="dialogVisible" :title="$t('operation.business_detail')" width="640px" :close-on-click-modal="false">
    <el-descriptions v-loading="loading" :column="1" border>
      <el-descriptions-item :label="$t('operation.business_no')">{{ detail.business_no || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.business_name')">{{ detail.business_name || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.business_type')">{{ getBusinessTypeLabel(detail.business_type) }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.business_region')">{{ detail.country_code || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.business_currency')">{{ detail.currency || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.related_franchisee')">{{ franchiseeInfo }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.description')">{{ detail.description || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.create_time')">{{ detail.create_time || '-' }}</el-descriptions-item>
    </el-descriptions>
    <div slot="footer">
      <el-button type="primary" @click="dialogVisible = false">{{ $t('components.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fetchBusinessDetail } from '@/api/operation-manage/business'

export default {
  name: 'BusinessDetailDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      detail: {}
    }
  },
  computed: {
    franchiseeInfo() {
      const parts = [this.detail.franchisee_no, this.detail.franchisee_name].filter(Boolean)
      return parts.length ? parts.join(' / ') : '-'
    }
  },
  methods: {
    showModal(business) {
      this.dialogVisible = true
      const businessNo = business && business.business_no
      if (!businessNo) {
        this.detail = business || {}
        return
      }
      this.loading = true
      fetchBusinessDetail(businessNo).then(response => {
        if (response.code === 10000) this.detail = response.data
      }).finally(() => {
        this.loading = false
      })
    },
    getBusinessTypeLabel(businessType) {
      const businessTypeLabels = { 1: this.$t('operation.self_operated'), 2: this.$t('operation.franchise') }
      return businessTypeLabels[businessType] || businessType || '-'
    }
  }
}
</script>
